
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;
   
    realEstate = [];
    totalRealEstate = 0;
    cars = [];
    totalCars = 0;
    cash = [];
    totalCash = 0;
    investment = [];
    totalInvestment = 0;
    loans = [];
    totalLoans = 0;
    other = [];
    totalOther = 0;
    total = 0;
    disposedAsset = false;
    disposedDesc = '';
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){  
        
        const assetTypes = this.result?.assetsFSSurvey?.assetTypes?this.result.assetsFSSurvey.assetTypes:[];
        this.total = 0;
        if(assetTypes.includes("realEstate")){
            this.getRealEstateInfo();
            this.total = this.total + this.totalRealEstate;
        } 
        if(assetTypes.includes("cars")){
            this.getCarInfo();
            this.total = this.total + this.totalCars;
        } 
        if(assetTypes.includes("cash")){
            this.getCashInfo();
            this.total = this.total + this.totalCash;
        } 
        if(assetTypes.includes("investments")){
            this.getInvestmentInfo();
            this.total = this.total + this.totalInvestment;
        } 
        if(assetTypes.includes("loans")){
            this.getLoanInfo();
            this.total = this.total + this.totalLoans;
        } 
        if(assetTypes.includes("otherAssets")){
            this.getOtherInfo();
            this.total = this.total + this.totalOther;
        }

        this.disposedAsset = false;
        this.disposedDesc = '';
        
        if(this.result?.dispositionAssetsFSSurvey?.soldAsset)
            this.disposedAsset = this.result.dispositionAssetsFSSurvey.soldAsset == 'y'

        if(this.disposedAsset && this.result?.dispositionAssetsFSSurvey?.soldAssetDescription)
            this.disposedDesc = this.result.dispositionAssetsFSSurvey.soldAssetDescription
        
    } 

    public getRealEstateInfo(){ 

        const emptyRealEstate = { desc: '', value: '' };
        this.realEstate = [];    
        this.totalRealEstate = 0;   

        if(this.result?.realEstateFSSurvey){  
            let totalRealEstateAmount = 0;          

            for(const realEstateSurvey of this.result.realEstateFSSurvey){
                let realEstateInfo = {
                    desc: realEstateSurvey.realEstateDescription?realEstateSurvey.realEstateDescription:'',                    
                    value: realEstateSurvey.realEstateValue?Number(realEstateSurvey.realEstateValue):0
                };
                this.realEstate.push(realEstateInfo);
                totalRealEstateAmount = totalRealEstateAmount +realEstateInfo.value;                
            }
            this.totalRealEstate = totalRealEstateAmount;
        }

        if(this.realEstate.length == 0){
            this.realEstate.push(emptyRealEstate);
        }            
    }

    public getCarInfo(){ 

        const emptyCar = { desc: '', value: '' };

        this.cars = [];    
        this.totalCars = 0;   

        if(this.result?.carsBoatsVehiclesFSSurvey){  
            let totalCarAmount = 0;          

            for(const carsSurvey of this.result.carsBoatsVehiclesFSSurvey){
                let carsInfo = {
                    desc: carsSurvey.carsBoatsVehiclesDescription?carsSurvey.carsBoatsVehiclesDescription:'',                    
                    value: carsSurvey.carsBoatsVehiclesValue?Number(carsSurvey.carsBoatsVehiclesValue):0
                };
                this.cars.push(carsInfo);
                totalCarAmount = totalCarAmount +carsInfo.value;                
            }
            this.totalCars = totalCarAmount;
        }

        if(this.cars.length == 0){
            this.cars.push(emptyCar);
        }            
    }

    public getCashInfo(){ 

        const emptyCash = { desc: '', value: '' };

        this.cash = [];    
        this.totalCash = 0;   

        if(this.result?.cashAssetsFSSurvey){  
            let totalCashAmount = 0;          

            for(const cashSurvey of this.result.cashAssetsFSSurvey){
                let cashInfo = {
                    desc: cashSurvey.cashAssetsDescription?cashSurvey.cashAssetsDescription:'',                    
                    value: cashSurvey.cashAssetsValue?Number(cashSurvey.cashAssetsValue):0
                };
                this.cash.push(cashInfo);
                totalCashAmount = totalCashAmount + cashInfo.value;                
            }
            this.totalCash = totalCashAmount;
        }

        if(this.cash.length == 0){
            this.cash.push(emptyCash);
        }            
    }

    public getInvestmentInfo(){ 

        const emptyInvestment = { desc: '', value: '' };

        this.investment = [];    
        this.totalInvestment = 0;   

        if(this.result?.investmentsFSSurvey){  
            let totalInvestmentAmount = 0;          

            for(const investmentSurvey of this.result.investmentsFSSurvey){
                let investmentInfo = {
                    desc: investmentSurvey.investmentsDescription?investmentSurvey.investmentsDescription:'',                    
                    value: investmentSurvey.investmentsValue?Number(investmentSurvey.investmentsValue):0
                };
                this.investment.push(investmentInfo);
                totalInvestmentAmount = totalInvestmentAmount + investmentInfo.value;                
            }
            this.totalInvestment = totalInvestmentAmount;
        }

        if(this.investment.length == 0){
            this.investment.push(emptyInvestment);
        }            
    }

    public getLoanInfo(){ 

        const emptyLoan = { desc: '', value: '' };

        this.loans = [];    
        this.totalLoans = 0;   

        if(this.result?.loansCreditsFSSurvey){  
            let totalLoanAmount = 0;          

            for(const loanSurvey of this.result.loansCreditsFSSurvey){
                let loanInfo = {
                    desc: loanSurvey.loansCreditsDescription?loanSurvey.loansCreditsDescription:'',                    
                    value: loanSurvey.loansCreditsValue?Number(loanSurvey.loansCreditsValue):0
                };
                this.loans.push(loanInfo);
                totalLoanAmount = totalLoanAmount + loanInfo.value;                
            }
            this.totalLoans = totalLoanAmount;
        }

        if(this.loans.length == 0){
            this.loans.push(emptyLoan);
        }            
    }

    public getOtherInfo(){ 

        const emptyOther = { desc: '', value: '' };

        this.other = [];    
        this.totalOther = 0;   

        if(this.result?.otherAssetsFSSurvey){  
            let totalOtherAmount = 0;          

            for(const otherSurvey of this.result.otherAssetsFSSurvey){
                let loanInfo = {
                    desc: otherSurvey.otherAssetsDescription?otherSurvey.otherAssetsDescription:'',                    
                    value: otherSurvey.otherAssetsValue?Number(otherSurvey.otherAssetsValue):0
                };
                this.other.push(loanInfo);
                totalOtherAmount = totalOtherAmount + loanInfo.value;                
            }
            this.totalOther = totalOtherAmount;
        }

        if(this.other.length == 0){
            this.other.push(emptyOther);
        }            
    }   
 
}
